// import axios from '../utils/axios';
import axios from 'axios';
import qs from 'qs';

// const API_URL = 'http://localhost:8000/api/v1/login';
const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/login';

export const auth = {
    isAuthenticated: false,
    authenticate(cb) {
        cb();
        console.log("inside service auth method");
        
        // this.isAuthenticated = true
    },
    signout(cb) {
        this.isAuthenticated = false
    }
}

export default function login(data) {
    return (
        axios.post(API_URL, qs.stringify(data))
            .then(res => {
                console.log("res: ", res);
                // console.log('res data', res.data);
                return res.data;

            })
            .catch(err => {
                console.log("hello errror");
                
                return err.data;
            })
    )
}